import { MenuItem } from "@mui/material"
import { MRT_Row } from "material-react-table"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { getEditProductRoute } from "../../../../../../constants/routes"
import { DefaultConfirmModalStateType } from "./DeleteProductDialog"
import { ProductTableRow } from "../../productsTypes"

type RenderRowActionMenuItemsProps = {
    row: MRT_Row<ProductTableRow>
    closeMenu: () => void
    setConfirmModalState: React.Dispatch<React.SetStateAction<DefaultConfirmModalStateType>>
    navigate: (path: string) => void
    errorClasses?: string
}

export const renderRowActionMenuItems = ({
    row,
    closeMenu,
    setConfirmModalState,
    navigate,
    errorClasses,
}: RenderRowActionMenuItemsProps) => {
    if (row.original.type === "group") return []

    return [
        <LocalizedStrict id="products-edit-product-menu-item" key={`edit-${row.original.id}`}>
            <MenuItem
                onClick={() => {
                    navigate(getEditProductRoute(row.original.id))
                    closeMenu()
                }}
            >
                Edit
            </MenuItem>
        </LocalizedStrict>,
        <LocalizedStrict id="products-delete-product-menu-item" key={`delete-${row.original.id}`}>
            <MenuItem
                className={errorClasses}
                onClick={() => {
                    setConfirmModalState({
                        showConfirmModal: true,
                        confirmModalText: `${row.original.name}`,
                        productId: row.original.id,
                    })
                    closeMenu()
                }}
            >
                Delete
            </MenuItem>
        </LocalizedStrict>,
    ]
}
